module.exports = __webpack_public_path__ + "media/images/icons/sort_both-cf6d51ce4c7c742164d3e4431fe1c7e3.png";